// extracted by mini-css-extract-plugin
export default {"ssShellSlideOutSidebar":"ShellSlideOutSidebar_ssShellSlideOutSidebar__7aLLc","ssShellSlideOutSidebar_open":"ShellSlideOutSidebar_ssShellSlideOutSidebar_open__TO3HX"};